// import React from "react";
import FormOrder from "./FormOrder";
// import { useTranslation } from "../../context/TranslationContext";
// import CalendarRuleCheckbox from "./CalendarRuleCheckbox";

const FilterSummary = ({ totalRecord, setParam }) => {
  // const { SearchResultFilterSummeryText } = useTranslation();
  return (
    <>
      <div className="flex items-center justify-between flex-col pt-4 ml:pt-0 ml:flex-row">
        {/* <div>
          <CalendarRuleCheckbox setParam={setParam} />
        </div> */}
        <span className="text-13 whitespace-nowrap font-poppins font-semibold">
          {/* {SearchResultFilterSummeryText.replace("{totalRecord}", totalRecord)} */}
        </span>
        <FormOrder setParam={setParam}></FormOrder>
      </div>
    </>
  );
};

export default FilterSummary;
